import {
    RaikoBaseCardContainer,
    RaikoCollapsibleTable,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage,
    showSuccessMessage,
    convertUniversalDateToPersianDate,
    prepareRaikoSelectBoxItem,
    createCollapsedTableRowData,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoButtonSecondary,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    RaikoConfirmDialog,
    RaikoLabelType,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {
    getHabitationRequestStatus,
    HabitationOrderTypes,
    HabitationRequestStatusTypes
} from "../periodList/periodDetails/HabitationRequestStatusTypes";
import {css} from "@emotion/css";
import React, {useState, useEffect} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import AddResidence from "../requestsList/AddResidence";
import RaikoHostSelectBox from "../../component/hostSelect/selectBox/RaikoHostSelectBox";

export default function ReserveList({periodId}) {


    const size = 15
    let page = 0

    let hostPage = 0
    const hostSize = 50

    const service = new PeriodService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [hostLoadingState, setHostLoadingState] = useState(false);
    const [reserveTableLoadingState, setReserveTableLoadingState] = useState(false);
    const [hostList, setHostList] = useState([prepareRaikoSelectBoxItem(-1, "همه", "ic-areas")]);
    const [reservedItems, setReservedItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);


    const [status, setStatus] = useState(HabitationRequestStatusTypes.ALL.id);
    const [order, setOrder] = useState(ReserveOrderTypes.START_DATE_DESC.id);

    const _statusFilter = useDebounce(status, 100);
    const _orderFilter = useDebounce(order, 100);


    const [selectedHostId, setSelectedHostId] = useState(-1);
    const [nationalCode, setNationalCode] = useState("");
    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [startDate, setStartDate] = useState('');

    const _SelectedHostIdFilter = useDebounce(selectedHostId, 50);

    const _fullNameFilter = useDebounce(fullName, 500);
    const _phoneNumberFilter = useDebounce(phoneNumber, 500);
    const _nationalCodeFilter = useDebounce(nationalCode, 500);

    const _startDateFilter = useDebounce(startDate, 500);

    useEffect(() => {
        page = 0
        getReserveList()
    }, [_SelectedHostIdFilter, _orderFilter, _statusFilter, _fullNameFilter, _phoneNumberFilter, _nationalCodeFilter, _startDateFilter])


    useEffect(() => {
        getInitialDataFromServer()
        getReserveList()
    }, [periodId]);

    function getInitialDataFromServer() {
        setHostLoadingState(true)
        service.getHostsList(periodId, hostPage, hostSize)
            .then(response => {
                response.data.map((item, index) => {
                    setHostList(prevState => [
                        ...prevState,
                        prepareRaikoSelectBoxItem(item.id, item.residence.metaData.title, "ic-areas")
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setHostLoadingState(false)
        })
    }

    function getReserveList() {
        setReserveTableLoadingState(true)
        service.getReservedList(
            periodId,
            _SelectedHostIdFilter,
            _fullNameFilter,
            _phoneNumberFilter,
            _nationalCodeFilter,
            _startDateFilter,
            _statusFilter,
            _orderFilter,
            page,
            size
        ).then(response => {
            console.log("response => ", response)

            setReservedItems([])
            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)

            response.data.map((item, index) => {
                setReservedItems(prevState => [
                    ...prevState,
                    createCollapsedTableRowData(
                        item.id,
                        getChildren(
                            item.lastChangesStatusAt,
                            item.lastChangedStatusBy,
                            item.status,
                            item.id
                        ),
                        prepareListRow(
                            (page * size) + index + 1,
                            item.id,
                            `${item.residentFirstName} ${item.residentLastName}`,
                            item.residentNationalCode,
                            item.residentPhoneNumber,
                            item.numberOfMen,
                            item.numberOfWomen,
                            item.startDate,
                            item.endDate,
                            item.residence && item.residence.metaData ? item.residence.metaData.title : "-",
                            item.lastChangesStatusAt,
                            item.lastChangedStatusBy,
                            item.status,
                        )
                    )

                ])
            })


        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setReserveTableLoadingState(false)
        })
    }


    // function getChildren(lastChangesStatusAt, lastChangedStatusBy, status, id) {
    //     return <RaikoGridOneColumn className={css`width: 100%;
    //         flex-grow: 1`}>
    //         <RaikoGridTwoColumn className={css`width: 100%;
    //             flex-grow: 1`}>
    //             <RaikoSimpleInputOutlined
    //                 labelText={"آخرین بروزرسانی"}
    //                 setValue={_ => {
    //                 }}
    //                 value={convertUniversalDateToPersianDate(lastChangesStatusAt)} disabled/>
    //             <RaikoSimpleInputOutlined labelText={"تغییر دهنده"} setValue={_ => {
    //             }} value={lastChangedStatusBy} disabled/>
    //         </RaikoGridTwoColumn>
    //         {
    //             status !== HabitationRequestStatusTypes.CANCELLED.id &&
    //             status !== HabitationRequestStatusTypes.REJECTED.id &&
    //             status !== HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id &&
    //
    //             <RaikoGridOneColumn>
    //                 <RaikoLabel
    //                     className={css`
    //                         font-family: iranYekanBold, sans-serif;
    //                         text-align: start;`}
    //                     text={"دسترسی ها"}/>
    //                 <RaikoGridThreeColumn>
    //                     <RaikoGridOneColumn>
    //                         <AddResidence
    //                             requestId={-1}
    //                             periodId={periodId}
    //                             reserveId={id}
    //                             doRefreshList={_ => {
    //                                 getReserveList()
    //                             }}
    //                         />
    //                     </RaikoGridOneColumn>
    //                     <RaikoGridOneColumn>
    //                         <RaikoButtonSecondary
    //                             className={css`background: var(--color-surface) !important`}
    //                             label={"لغو اسکان"}
    //                             onClick={e => {
    //                                 setSelectedReserveId(id)
    //                                 setOpenConfirmDialog(true)
    //                             }}
    //
    //                         />
    //                     </RaikoGridOneColumn>
    //                 </RaikoGridThreeColumn>
    //             </RaikoGridOneColumn>
    //         }
    //     </RaikoGridOneColumn>
    // }

    function getChildren(lastChangesStatusAt, lastChangedStatusBy, status, id) {
        return <RaikoCardInfoTypeOne
            hasBottomChildren
            title={"جزئیات درخواست"}
            items={[
                RaikoCardInfoTypeOneItemGenerator("آخرین بروزرسانی", convertUniversalDateToPersianDate(lastChangesStatusAt)),
                RaikoCardInfoTypeOneItemGenerator("تغییر دهنده", lastChangedStatusBy)]}
        >
            {
                status !== HabitationRequestStatusTypes.CANCELLED.id &&
                status !== HabitationRequestStatusTypes.REJECTED.id &&
                status !== HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id &&

                <RaikoGridOneColumn>
                    <RaikoLabel
                        className={css`
                            font-family: iranYekanBold, sans-serif;
                            text-align: start;`}
                        text={"دسترسی ها"}/>
                    <RaikoGridTwoColumn>
                        <RaikoGridOneColumn>
                            <AddResidence
                                requestId={-1}
                                periodId={periodId}
                                reserveId={id}
                                doRefreshList={_ => {
                                    getReserveList()
                                }}
                            />
                        </RaikoGridOneColumn>
                        <RaikoGridOneColumn>
                            <RaikoButtonSecondary
                                className={css`background: var(--color-surface) !important`}
                                label={"لغو اسکان"}
                                onClick={e => {
                                    setSelectedReserveId(id)
                                    setOpenConfirmDialog(true)
                                }}

                            />
                        </RaikoGridOneColumn>
                    </RaikoGridTwoColumn>
                </RaikoGridOneColumn>
            }
        </RaikoCardInfoTypeOne>
    }

    function prepareListRow(number, id, fullName, nationalCode, phoneNumber, numberOfMen, numberOfWomen, startDate, endDate, residenceTitle, lastChangesStatusAt, lastChangedStatusBy, status) {

        let statusChip

        if (status === HabitationRequestStatusTypes.POSTED.id ||
            status === HabitationRequestStatusTypes.IN_AWAITING_LIST.id ||
            status === HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.id ||
            status === HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.id
        ) {
            statusChip =
                <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.warning}/>
        } else if (
            status === HabitationRequestStatusTypes.REJECTED.id ||
            status === HabitationRequestStatusTypes.CANCELLED.id ||
            status === HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id) {
            statusChip = <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.error}/>
        } else if (
            status === HabitationRequestStatusTypes.SUBMITTED.id ||
            status === HabitationRequestStatusTypes.REFERRED.id) {
            statusChip =
                <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.success}/>
        }


        return {
            number,
            id,
            teamLeader: fullName,
            menCapacity: numberOfMen,
            womenCapacity: numberOfWomen,
            requesterPhoneNumber: phoneNumber,
            status: statusChip,
            residenceTitle: residenceTitle,
            startDate: startDate ? convertUniversalDateToPersianDate(startDate) : "-",
            endDate: endDate ? convertUniversalDateToPersianDate(endDate) : "-",
            lastChangesStatusAt: lastChangesStatusAt ? convertUniversalDateToPersianDate(lastChangesStatusAt) : "-",
            lastChangedStatusBy: lastChangedStatusBy,
            requesterNationalCode: nationalCode,
        }
    }


    function handlePagination(newPage) {
        page = newPage
        getReserveList()
    }

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [selectedReserveId, setSelectedReserveId] = useState(-1);


    function handleCloseConfirmDialog() {
        setOpenConfirmDialog(false)
    }

    function handleReject() {
        loading.show()
        service.rejectReserve(selectedReserveId)
            .then(response => {
                showSuccessMessage("اسکان با موفقیت لغو شد.")
                getReserveList()
                setOpenConfirmDialog(false)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleDeleteAllFilters() {
        setPhoneNumber("")
        setNationalCode("")
        setStartDate("")
        setOrder(ReserveOrderTypes.START_DATE_DESC.id)
        setStatus(HabitationRequestStatusTypes.ALL.id)
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openConfirmDialog}
                cancelAction={handleCloseConfirmDialog}
                pageTitle={"اسکان ها"}
                warningTitle={"آیا از لغو اسکان کاربر اطمینان دارید؟"}
                warningDescription={"با لغو اسکان امکان تغییر وضعیت درخواست وجود نخواهد داشت"}
                confirmButtonTitle={"لغو اسکان"}
                doAction={handleReject}/>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBaseCardContainer className={css`width: 100%;
                        overflow: hidden`}>
                        <RaikoLabel raikoLabelType={RaikoLabelType.TITLE} text={"فیلتر اقامتگاه"}/>
                        <RaikoHostSelectBox
                            periodId={periodId}
                            isHorizontal
                            setSelectedHost={setSelectedHostId}
                            selectedHost={selectedHostId}
                        />
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اسکان ها"}
                            amount={totalItems}
                        />
                        <RaikoTableSearchContainer
                            labelText={"نام و نام خانوادگی"}
                            hasFilter
                            setValue={setFullName}
                            value={fullName}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                phoneNumber.length > 0 || nationalCode.length > 0 || startDate.length > 0 ||
                                order.length > 0 && ReserveOrderTypes.START_DATE_DESC.id !== order ||
                                status.length > 0 && HabitationRequestStatusTypes.ALL.id !== status
                            }
                        >
                            <RaikoGridOneColumn>
                                <RaikoCustomSelect
                                    labelText={"چینش"}
                                    setValue={setOrder}
                                    value={order}
                                    items={[
                                        raikoCustomSelectItemGenerator(ReserveOrderTypes.START_DATE_DESC.id, ReserveOrderTypes.START_DATE_DESC.title),
                                        raikoCustomSelectItemGenerator(ReserveOrderTypes.START_DATE_ASC.id, ReserveOrderTypes.START_DATE_ASC.title),
                                    ]}
                                />

                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    setValue={setStatus}
                                    value={status}
                                    items={[
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.ALL.id, HabitationRequestStatusTypes.ALL.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.SUBMITTED.id, HabitationRequestStatusTypes.SUBMITTED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.REFERRED.id, HabitationRequestStatusTypes.REFERRED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.REJECTED.id, HabitationRequestStatusTypes.REJECTED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id, HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.CANCELLED.id, HabitationRequestStatusTypes.CANCELLED.title),
                                    ]}
                                />
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumber}
                                    value={phoneNumber}/>

                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    setValue={setNationalCode}
                                    value={nationalCode}/>
                                <RaikoDatePicker
                                    label={"تاریخ"}
                                    date={startDate}
                                    setDate={setStartDate}
                                />
                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>
                        <RaikoCollapsibleTable
                            data={reservedItems}
                            header={reserveListTableHeader}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            isLoading={reserveTableLoadingState}

                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}

export const ReserveOrderTypes = {
    START_DATE_DESC: {
        id: "START_DATE_DESC",
        title: "جدیدترین ها"
    },
    START_DATE_ASC: {
        id: "START_DATE_ASC",
        title: "قدیمی ترین ها"
    },
}

const reserveListTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "teamLeader",
        label: "سرگروه",
    },
    {
        id: "requesterNationalCode",
        label: "کد ملی",
    },
    {
        id: "requesterPhoneNumber",
        label: "شماره همراه",
    },
    {
        id: "menCapacity",
        label: "تعداد آقا",
    },
    {
        id: "womenCapacity",
        label: "تعداد خانم",
    },
    {
        id: "residenceTitle",
        label: "اقامتگاه",
    },
    {
        id: "startDate",
        label: "شب اول",
    },
    {
        id: "endDate",
        label: "شب آخر",
    },
    /* {
         id: "lastChangesStatusAt",
         label: "آخرین بروزرسانی",
     },
     {
         id: "lastChangedStatusBy",
         label: "تغییر دهنده",
     },*/
    {
        id: "status",
        label: "وضعیت"
    }
]